import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, withModifiers as _withModifiers, normalizeClass as _normalizeClass, withCtx as _withCtx, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, resolveDirective as _resolveDirective, withDirectives as _withDirectives, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = { class: "avatar-uploader" }
const _hoisted_2 = { class: "avatar-block" }
const _hoisted_3 = ["accept"]
const _hoisted_4 = { class: "image" }
const _hoisted_5 = { class: "description" }
const _hoisted_6 = { class: "file" }

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_Avatar = _resolveComponent("Avatar")
  const _component_Icon = _resolveComponent("Icon")
  const _component_FileIcon = _resolveComponent("FileIcon")
  const _component_Segment = _resolveComponent("Segment")
  const _component_UploadItem = _resolveComponent("UploadItem")
  const _component_ScrollBar = _resolveComponent("ScrollBar")
  const _directive_resize = _resolveDirective("resize")

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_component_Avatar, {
          image_id: $options.avatar_id,
          name: $options.display_name,
          height: "6.4rem",
          width: "6.4rem"
        }, null, 8 /* PROPS */, ["image_id", "name"])
      ]),
      _createVNode(_component_Segment, {
        class: _normalizeClass(["uploader-segment", {active: _ctx.active, empty: !$options.avatar_id}]),
        relative: "",
        onDragover: _cache[3] || (_cache[3] = _withModifiers(ev => _ctx.dragover(ev), ["prevent"])),
        onDrop: _cache[4] || (_cache[4] = _withModifiers(ev => _ctx.drop(ev), ["prevent"])),
        onDragleave: _cache[5] || (_cache[5] = _withModifiers(ev => _ctx.dragleave(ev), ["prevent"]))
      }, {
        default: _withCtx(() => [
          _createElementVNode("input", {
            id: "file",
            ref: "file",
            type: "file",
            accept: _ctx.accept,
            style: {"display":"none"},
            onClick: _cache[0] || (_cache[0] = $event => (_ctx.onFileInput())),
            onChange: _cache[1] || (_cache[1] = (...args) => (_ctx.onDrop && _ctx.onDrop(...args)))
          }, null, 40 /* PROPS, NEED_HYDRATION */, _hoisted_3),
          _createElementVNode("div", {
            class: "drop-block pointer",
            onClick: _cache[2] || (_cache[2] = $event => (_ctx.$refs.file.click()))
          }, [
            _createElementVNode("div", _hoisted_4, [
              _createVNode(_component_Icon, {
                class: "upload-icon",
                icon: "upload-cloud-02",
                width: "2rem",
                height: "2rem"
              })
            ]),
            _createElementVNode("div", _hoisted_5, [
              _cache[7] || (_cache[7] = _createElementVNode("div", null, [
                _createElementVNode("span", { class: "click-to" }, "Click to upload"),
                _createTextVNode(" or drag and drop")
              ], -1 /* HOISTED */)),
              _createElementVNode("div", null, _toDisplayString(_ctx.allowed_types_text) + " (max " + _toDisplayString(_ctx.$utils.format.bytes(_ctx.maxSize)) + ")", 1 /* TEXT */)
            ])
          ]),
          _createElementVNode("div", _hoisted_6, [
            _createVNode(_component_FileIcon, { ext: "jpg" }),
            _createVNode(_component_Icon, {
              icon: "custom/cursor",
              class: "cursor",
              width: "2rem",
              height: "2rem"
            })
          ])
        ]),
        _: 1 /* STABLE */
      }, 8 /* PROPS */, ["class"])
    ]),
    _createCommentVNode(" Uploads list "),
    (_ctx.uploads?.length)
      ? (_openBlock(), _createBlock(_component_Segment, {
          key: 0,
          class: "list"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_ScrollBar, {
              ref: "uploads_scroll",
              style: _normalizeStyle({'height': _ctx.uploads_height})
            }, {
              default: _withCtx(() => [
                _withDirectives((_openBlock(), _createElementBlock("div", {
                  style: {"display":"grid","gap":"0.1rem"},
                  onClick: _cache[6] || (_cache[6] = _withModifiers(() => {}, ["stop"]))
                }, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.uploads, (upload) => {
                    return (_openBlock(), _createBlock(_component_UploadItem, {
                      id: upload.id,
                      key: upload.id,
                      ref_for: true,
                      ref: "uploads",
                      mode: _ctx.mode,
                      instance: upload,
                      class: "item",
                      inline: true,
                      onDelete: $event => (_ctx.store.deleteUpload(upload.id))
                    }, null, 8 /* PROPS */, ["id", "mode", "instance", "onDelete"]))
                  }), 128 /* KEYED_FRAGMENT */))
                ])), [
                  [_directive_resize, _ctx.onUploadsResize]
                ])
              ]),
              _: 1 /* STABLE */
            }, 8 /* PROPS */, ["style"])
          ]),
          _: 1 /* STABLE */
        }))
      : _createCommentVNode("v-if", true)
  ], 64 /* STABLE_FRAGMENT */))
}